import { apiCall } from "./index";

export const uploadHolidays = (formData) => {
  return apiCall(`/holiday-calendar/upload`, "POST", formData, null, true);
};

export const getHolidays = () => {
  return apiCall(`/holiday-calendar`);
};